
function inMemoryStorage() {
    let storage = {};

    return {
        getItem: function (key) {
            return storage[key];
        },
        setItem: function (key, value) {
            storage[key] = value;
        },
        removeItem: function (key) {
            delete storage[key];
        },
        clear: function () {
            storage = {};
        }
    };
}

function StorageWrapper(storage) {
    try {
        // Check for support (browsers in privacy mode)
        let key = 'test-local-storage-support';
        storage.setItem(key, '1');
        storage.removeItem(key);
        this._storage = storage;
    } catch (ex) {
        this._storage = inMemoryStorage();
    }
}

let p = StorageWrapper.prototype;

p.get = function (key) {
    return this._storage.getItem(key);
};

p.set = function (key, value) {
    this._storage.setItem(key, value);
};

p.remove = function (key) {
    this._storage.removeItem(key);
};

p.clear = function () {
    this._storage.clear();
};

p.length = function () {
    return this._storage.length;
};

p.getKey = function (i) {
    return this._storage.key(i);
};

p.clearByPrefix = function (prefix) {
    // Loop in reverse because storage indexes will change as you delete items.
    for (let i = this._storage.length - 1; i > -1; --i) {
        let name = this.getKey(i);
        if (name.indexOf(prefix) === 0) {
            this.remove(name);
        }
    }
};

export default  {
    local: function () {
        let lStorage = false;
        try {
            lStorage = window.localStorage; // This will throw an exception in some browsers when cookies/localStorage are explicitly disabled (i.e. Chrome)
            lStorage.setItem('TEST', '1');
            lStorage.removeItem('TEST');
        } catch (e) {
            lStorage = false;
        }

        return new StorageWrapper(lStorage);
    },
    session: function () {
        let sStorage = false;
        try {
            sStorage = window.sessionStorage; // This will throw an exception in some browsers when cookies/localStorage are explicitly disabled (i.e. Chrome)
            sStorage.setItem('TEST', '1');
            sStorage.removeItem('TEST');
        } catch (e) {
            sStorage = false;
        }

        return new StorageWrapper(sStorage);
    },
    inMemory: function (/* optional */ storage) {
        if (storage) {
            return new StorageWrapper(storage);
        } else {
            return new StorageWrapper(inMemoryStorage());
        }
    }
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/storage-factory.js